<template>
    <transition name="modal">
        <div class="modal-mask" @click="$emit('close')">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <button type="button" class="close" @click="$emit('close')" data-dismiss="modal"
                            aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="modal-body">
                        <template v-if="mime === 'application/pdf'">
                            <object v-bind:data="src" type="application/pdf">
                                <p class="m-4">
                                    Your browser does not support view {{mime}} file, please <a v-bind:href="download" class="btn btn-primary">Click Here</a> to download the file.
                                </p>
                            </object>
                        </template>
                        <template v-else>
                            <p class="m-4">
                                Please <a v-bind:href="download" class="btn btn-primary">Click Here</a> to download the file.
                            </p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
  export default {
    props: {
      url: String,
      mime: String
    },
    computed: {
      src: function () {
        return this.url + '#toolbar=1';
      },
      download: function () {
        return this.url + '&download=1';
      }
    }
  }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        position: relative;
        max-width: 802px;
        width: 90%;
        height: 80%;
        margin: 0 auto;
        padding: 0;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
    .close {
        position: absolute;
        z-index: 1;
        top:0;
        right: 0;
        display: block;
        width: 32px;
        height: 32px;
        margin-right: -16px;
        margin-top: -16px;
        background-color: white;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        opacity: 1;
    }

    .modal-body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        max-height: 100%;
    }

    .modal-body object {
        width: 100%;
        height: 100%;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>